// src/App.tsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Dashboard from "./pages/admin/Dashboard";
import BancosPage from "./pages/admin/BancosPage";
import ProveedoresPage from "./pages/admin/ProveedoresPage";
import OdesPage from "./pages/admin/OdesPage";
import OdesDetailPage from "./pages/admin/OdesDetailPage"; // 👈 IMPORTAR
import GastosPage from "./pages/admin/GastosPage";
import ReportesPage from "./pages/admin/ReportesPage";
import SidebarResponsive from "./components/Sidebar";
import LoginPage from "./pages/LoginPage";

function App() {
  const [isAuthed, setIsAuthed] = useState(() => !!sessionStorage.getItem("token"));

  useEffect(() => {
    const interval = setInterval(() => {
      const token = sessionStorage.getItem("token");
      setIsAuthed(!!token);
    }, 100); 
    return () => clearInterval(interval);
  }, []);

  const ProtectedRoute = ({ element }: { element: JSX.Element }) => {
    return isAuthed ? element : <Navigate to="/login" />;
  };

  return (
    <BrowserRouter basename="/">
      <div className="min-h-screen w-full">
        {isAuthed && <SidebarResponsive />}

        <main className={`mx-auto max-w-7xl px-3 sm:px-6 py-6`}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Navigate to="/admin" />} />

            <Route path="/admin" element={<ProtectedRoute element={<Dashboard />} />} />
            <Route path="/admin/bancos" element={<ProtectedRoute element={<BancosPage />} />} />
            <Route path="/admin/odes" element={<ProtectedRoute element={<OdesPage />} />} />
            <Route path="/admin/odes/:id" element={<ProtectedRoute element={<OdesDetailPage />} />} /> {/* 👈 AGREGADO */}
            <Route path="/admin/proveedores" element={<ProtectedRoute element={<ProveedoresPage />} />} />
            <Route path="/admin/gastos" element={<ProtectedRoute element={<GastosPage />} />} />
            <Route path="/admin/reportes" element={<ProtectedRoute element={<ReportesPage />} />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
